var __jsx = React.createElement;
import React from 'react';
import { Dot, LoaderContainer, LoaderWrapper } from './Loader.style'; // Loader from https://loading.io/css/

var Loader = function Loader() {
  return __jsx(LoaderWrapper, {
    role: "progressbar"
  }, __jsx(LoaderContainer, null, __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null), __jsx(Dot, null)));
};

export default Loader;